import { useState, useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { useThemes } from './useThemes';

export function useAccordion() {
    const location = useLocation();
    const { themes } = useThemes();
    const [accordion, setAccordionState] = useState([]);
    // Stato per tracciare l'ultimo index processato
    const [processedIndex, setProcessedIndex] = useState(null);

    useEffect(() => {
        // Inizializzazione
    const abruzzo_Theme = themes[3] ? (themes[3].accordion || []) : []; // Prende direttamente l'elemento all'indice Abruzzo
    const aquila_Theme = themes[4]? (themes[4].accordion || []) : []; // Prende direttamente l'elemento all'indice Aquila
    const chieti_Theme = themes[5]? (themes[5].accordion || []) : []; // Prende direttamente l'elemento all'indice chieti
    const pescara_Theme = themes[6]? (themes[6].accordion || []) : []; // Prende direttamente l'elemento all'indice pescara 
    const teramo_Theme = themes[7]? (themes[7].accordion || []) : []; // Prende direttamente l'elemento all'indice teramo

        const accordionData = [abruzzo_Theme, aquila_Theme, chieti_Theme, pescara_Theme, teramo_Theme]
            .filter(accordionArray => Array.isArray(accordionArray) && accordionArray.length > 0)
            .map(accordionArray => accordionArray[0]);

        if (accordionData.length > 0) {
            setAccordionState(accordionData);
        }
    }, [themes]);

    useEffect(() => {
        const currentIndex = location.state?.index;
        
        // Se non c'è index o accordion non è pronto, esci
        if (currentIndex === undefined || accordion.length === 0) return;
        
        // Se è lo stesso index già processato, esci
        if (currentIndex === processedIndex) {
            console.log("Index già processato:", currentIndex);
            return;
        }
        
        console.log("Nuovo index da processare:", currentIndex);
        setProcessedIndex(currentIndex);
        
        setAccordionState(prev => {
            const updated = [...prev];
            
            updated.forEach(item => {
                // Reset di tutti gli accordion
                item.isActive = false;
                item.color = '#379683';
                
                // Imposta quello attuale
                if (item.id_accord === currentIndex) {
                    item.isActive = true;
                    item.color = "#e85a4f";
                }
                
                // Caso speciale per index = 1
                if (currentIndex === 1 && item.id_accord === 1) {
                    item.color = "#e85a4f";
                }
            });
            
            return updated;
        });
    }, [location.state?.index, accordion.length, processedIndex]);

    return { accordion, setAccordionState, themes };
}
